import { Image, Row, Skeleton, Typography } from 'antd';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Router from '../../router/Router';
import './_loginlayout.scss';
import PrimaryButton from '../../components/UI/Button/Button';

interface LoginLayoutProps {
  isErrorPage?: boolean;
  ssoUrl?: string | null;
}

const LoginLayout: FC<LoginLayoutProps> = ({ isErrorPage, ssoUrl }) => {
  const navigate = useNavigate(),
    logo = useSelector((state: any) => state.theme.logoUrl),
    location = useLocation();

  const handleSSOLogin = () => {
    window.location.href = ssoUrl || location.pathname;
  };

  return (
    <>
      <div className="login-container">
        <Row justify="center">
          {!logo && <Skeleton.Image className="logo" />}
          {logo && <Image src={logo} preview={false} className="logo" onClick={() => navigate('/')} />}
        </Row>
        <Row justify="center">
          <div className="login-box">
            <div className={`login-content ${isErrorPage ? 'error-page' : ''}`}>
              {ssoUrl ? (
                <div className="sso-content">
                  <div className="sso-title">
                    <Typography.Title level={3}>Login to your Dashboard</Typography.Title>
                  </div>
                  <PrimaryButton onClick={handleSSOLogin}>SIGN IN WITH SSO</PrimaryButton>
                </div>
              ) : (
                <Router />
              )}
            </div>
          </div>
        </Row>
        {/* <Row justify="center">
          <div className="footer">© Safetynet Innovations Private Limited</div>
        </Row> */}
      </div>
    </>
  );
};

export default LoginLayout;
